export enum FournisseurType {
    Webimm = 9,
    DCF = 12
}
